import React from 'react';

export const LoadingSkeleton = ({ type = 'list' }) => {
  if (type === 'list') {
    return (
      <div className="container page-skeleton-wrapper">
        <div className="skeleton-base sk-title"></div>
        <div className="skeleton-base sk-subtitle"></div>
        <div className="sk-grid">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div key={i} className="sk-card">
              <div className="skeleton-base sk-card-img"></div>
              <div className="skeleton-base sk-card-text"></div>
              <div className="skeleton-base sk-card-text-sm"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'detail') {
    return (
      <div className="container page-skeleton-wrapper">
        <div style={{ display: 'flex', gap: '40px', marginTop: '40px' }} className="mobile-stack">
          <div style={{ flex: 1.5 }}>
            <div className="skeleton-base" style={{ width: '100%', height: '450px', borderRadius: '16px' }}></div>
          </div>
          <div style={{ flex: 1 }}>
            <div className="skeleton-base" style={{ width: '70%', height: '32px', marginBottom: '20px' }}></div>
            <div className="skeleton-base" style={{ width: '40%', height: '40px', marginBottom: '40px' }}></div>
            <div className="skeleton-base" style={{ width: '100%', height: '150px', borderRadius: '12px' }}></div>
          </div>
        </div>
      </div>
    );
  }
  
  return null;
};